const endpoints = {
	base: process.env.REACT_APP_BASE_API
}

export default endpoints
